/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Deal_Stage_ChangedInputs */

const cs_enum_deal_stage_changed = /** @type {(inputs: Enum_Deal_Stage_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změna fáze obchodu`)
};

const en_enum_deal_stage_changed = /** @type {(inputs: Enum_Deal_Stage_ChangedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deal stage changed`)
};

/**
* | output |
* | --- |
* | "Deal stage changed" |
*
* @param {Enum_Deal_Stage_ChangedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_deal_stage_changed = /** @type {((inputs?: Enum_Deal_Stage_ChangedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Deal_Stage_ChangedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_deal_stage_changed(inputs)
	return cs_enum_deal_stage_changed(inputs)
});